import React, { useState, useEffect } from 'react'

interface Args {
  isFrozenOnceVisible?: boolean
}

const useOnScreen = (ref: React.MutableRefObject<Element | null>, { isFrozenOnceVisible = false }: Args): boolean => {
  const [isIntersecting, setIntersecting] = useState(false)

  const frozen = isFrozenOnceVisible && isIntersecting

  const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting))

  useEffect(() => {
    const node = ref?.current
    const hasOSSupport = !!window.IntersectionObserver

    if (frozen || !node || !hasOSSupport) return

    observer.observe(node)

    return () => observer.disconnect()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, frozen])

  return isIntersecting
}

export default useOnScreen
